import { ChangeDetectionStrategy, Component, effect, inject, input, LOCALE_ID } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { PolishDateAdapter } from '@/common/polish-date-adapter/polish-date-adapter';
import { SalaryExternalSystemsComponent } from './_components/salary-external-systems.component';
import { SalaryPendingDraftsComponent } from './_components/salary-pending-drafts.component';
import { SalarySettlementBonusesComponent } from './_components/salary-settlement-bonuses.component';
import { SalarySummaryComponent } from './_components/salary-summary.component';
import { DriversSalaryV2StateService } from './_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-drivers-salary-v2',
	standalone: true,
	imports: [
		SalaryPendingDraftsComponent,
		SalaryExternalSystemsComponent,
		SalarySettlementBonusesComponent,
		SalarySummaryComponent,
	],
	templateUrl: './drivers-salary-v2.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{ provide: LOCALE_ID, useValue: 'pl-PL' },
		{ provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
		{ provide: DateAdapter, useClass: PolishDateAdapter },
	],
})
export class DriversSalaryV2Component {
	readonly driverId = input.required<string>();
	readonly selectedMonth = input.required<string>();
	readonly active = input<boolean>(false);

	private readonly state = inject(DriversSalaryV2StateService);

	constructor() {
		effect(
			() => {
				this.state.setContext(this.driverId(), this.selectedMonth());
				if (this.active()) {
					this.state.reload();
				}
			},
			{ allowSignalWrites: true },
		);
	}
}
